export function setUserInfoToLocalStorage(user) {
    if(!user) return localStorage.setItem('user', user);
    localStorage.setItem('user', JSON.stringify(user));
}

export function getUserToken() {
    return localStorage.getItem('token');
}

export function getHashedUserToken() {
    return localStorage.getItem('token');
}


export function setJWTToken(token){
    localStorage.setItem('token', token);
}

export function getUserInfoFromLocalStorage() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
}

export function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

export function stringAvatar(name) {
    name = name.replace(/  +/g, ' ');
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
}

export function removeEmpty(obj) {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([_, v]) => v !== null && v !== undefined && v !== '')
        .map(([k, v]) => [k, v === Object(v) ? removeEmpty(v) : v])
    );
}

export function isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
}

export function getBase64FromFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
